import { getFormattedPhoneNumber } from "utils/helperFunctions";
import { phoneCountryCodes } from "utils/helperConstants";

// reformat the candidate phone number by removing the country code, parentheses, and dash
export const getCandidates = (candidates) => {
  const reformattedCandidates = candidates.map((candidate) => {
    const newCandidate = candidate;

    const { phoneCountryCode, phoneNumber } = candidate;

    // reformat the candidate phone number if one was added
    // if not added, then set phoneCountryCode and phoneNumber to null
    if (phoneCountryCode && phoneNumber) {
      newCandidate.phoneNumber = candidate.phoneNumber
        .replace(`${phoneCountryCode} `, "")
        .replace(/\D/g, "");
    } else {
      newCandidate.phoneNumber = null;
      newCandidate.phoneCountryCode = null;
    }

    return newCandidate;
  });

  return reformattedCandidates;
};

export const getPhoneNumberCountryCodeAbbreviation = (phoneNumber) => {
  let countryCode = "";

  if (phoneNumber && phoneNumber.includes("+1")) {
    countryCode = "US";
  } else if (phoneNumber && phoneNumber.includes("+61")) {
    countryCode = "AU";
  }

  return countryCode;
};

export const getNewCandidatePhoneNumber = (
  oldPhoneNumber,
  newPhoneNumber,
  countryCode
) => {
  // if the old phone number is empty, then return the new phone number
  // the country code and phone number formatting will be at the discretion of the user
  if (oldPhoneNumber === "") {
    return newPhoneNumber;
  }

  const formattedPhoneNumber = newPhoneNumber
    ? getFormattedPhoneNumber(
        newPhoneNumber,
        phoneCountryCodes[countryCode],
        countryCode
      )
    : "";

  return formattedPhoneNumber;
};

export const getTimeFactorFormValues = (timeFactor) =>
  timeFactor !== 1.0 ? timeFactor : null;

export const getEventProctoringSettings = (
  proctoring,
  supervised,
  proctoringConfiguration
) => {
  const isEventProctoringEnabled = proctoring && !supervised;
  return {
    enabled: isEventProctoringEnabled,
    ...(isEventProctoringEnabled && { configuration: proctoringConfiguration }),
  };
};
